import { authRequest } from './authApi';

export interface LLMSettings {
  configured: boolean;
  enabled: boolean;
  base_url: string;
  model: string;
  has_api_key: boolean;
  timeout_seconds?: number;
  updated_at?: string;
}

export interface SaveLLMSettingsPayload {
  enabled?: boolean;
  base_url: string;
  model: string;
  api_key?: string;
  timeout_seconds?: number;
}

async function parseError(res: Response): Promise<Error> {
  const data = await res.json().catch(() => ({})) as Record<string, string>;
  return new Error(data.message || data.error || `HTTP ${res.status}`);
}

export async function getLLMSettings(): Promise<LLMSettings> {
  const res = await authRequest('/me/llm-settings');
  if (!res.ok) throw await parseError(res);
  return res.json();
}

export async function saveLLMSettings(payload: SaveLLMSettingsPayload): Promise<LLMSettings> {
  const res = await authRequest('/me/llm-settings', {
    method: 'PUT',
    body: JSON.stringify(payload),
  });
  if (!res.ok) throw await parseError(res);
  return res.json();
}

export async function resetLLMSettings(): Promise<void> {
  const res = await authRequest('/me/llm-settings', { method: 'DELETE' });
  if (!res.ok) throw await parseError(res);
}
